var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLabelQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2C4.23478 2 3.98043 2.10536 3.79289 2.29289C3.60536 2.48043 3.5 2.73478 3.5 3V13C3.5 13.2652 3.60536 13.5196 3.79289 13.7071C3.98043 13.8946 4.23478 14 4.5 14H11.5C11.7652 14 12.0196 13.8946 12.2071 13.7071C12.3946 13.5196 12.5 13.2652 12.5 13V6.91414C12.5 6.91411 12.5 6.91409 12.5 6.91406C12.5 6.78155 12.4473 6.65447 12.3536 6.56074C12.3536 6.56073 12.3536 6.56071 12.3536 6.5607L7.9393 2.14641C7.84557 2.0527 7.71847 2.00004 7.58594 2C7.58591 2 7.58589 2 7.58586 2H4.5ZM3.08579 1.58579C3.46086 1.21071 3.96957 1 4.5 1H7.58601C7.9837 1.00006 8.36509 1.15804 8.64633 1.43922L8.64637 1.43926L13.0608 5.85367C13.342 6.13491 13.4999 6.5163 13.5 6.91399V13C13.5 13.5304 13.2893 14.0391 12.9142 14.4142C12.5391 14.7893 12.0304 15 11.5 15H4.5C3.96957 15 3.46086 14.7893 3.08579 14.4142C2.71071 14.0391 2.5 13.5304 2.5 13V3C2.5 2.46957 2.71071 1.96086 3.08579 1.58579Z",
    fill: "#10B981"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.25C8.27614 1.25 8.5 1.47386 8.5 1.75V5.5C8.5 5.63261 8.55268 5.75978 8.64645 5.85355C8.74022 5.94732 8.86739 6 9 6H12.75C13.0261 6 13.25 6.22386 13.25 6.5C13.25 6.77614 13.0261 7 12.75 7H9C8.60217 7 8.22064 6.84196 7.93934 6.56066C7.65804 6.27936 7.5 5.89783 7.5 5.5V1.75C7.5 1.47386 7.72386 1.25 8 1.25Z",
    fill: "#10B981"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9C5 8.72386 5.22386 8.5 5.5 8.5H10.5C10.7761 8.5 11 8.72386 11 9C11 9.27614 10.7761 9.5 10.5 9.5H5.5C5.22386 9.5 5 9.27614 5 9Z",
    fill: "#10B981"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.5C5 11.2239 5.22386 11 5.5 11H10.5C10.7761 11 11 11.2239 11 11.5C11 11.7761 10.7761 12 10.5 12H5.5C5.22386 12 5 11.7761 5 11.5Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLabelQuestion);
export default __webpack_public_path__ + "static/media/add-label-question.90367b9896d9fd21092679f6bc6b3cf0.svg";
export { ForwardRef as ReactComponent };